function isFunc(fn : any) : fn is Function{
	return typeof fn === 'function'
}

export default function mergeFuncs<R extends any[],T extends any>(sourceFn : (...args : R)=> T,...fns : ((...args : R)=> T)[] ) : ((...args : R)=> T) {
	if(!isFunc(sourceFn)){
		throw new TypeError("sourceFn must be a function")
	}
	if (arguments.length > 1) {
		return function(this : any,...args : R) : T{
			let result : T = sourceFn.apply(this,args)
			let len = fns.length
			for(let i = 0; i < len; i++ ){
				if (isFunc(fns[i])) {
					fns[i].apply(this,args)
				}
			}
			return result 
		}
	}else{
		return sourceFn
	}
}